import { useCallback, useEffect, useRef, useState } from "react";
import { activeMonth } from "./activeMonth";
import { readFounderMonth } from "./monthAdapter";
import type { FounderMonth } from "./types";

/** Static month first. A usable database month replaces it; failures do not. */
export function useFounderMonth(): {
  month: FounderMonth;
  notice: string | null;
  refresh: () => Promise<void>;
} {
  const [month, setMonth] = useState<FounderMonth>(activeMonth);
  const [notice, setNotice] = useState<string | null>(null);
  const seq = useRef(0);

  const refresh = useCallback(async () => {
    const ticket = ++seq.current;
    const read = await readFounderMonth();
    if (ticket !== seq.current) return;
    setMonth(read.month ?? activeMonth);
    setNotice(read.month ? null : read.notice);
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { month, notice, refresh };
}
